import { TimespanType_Day } from '@app/hcs-shared';
import { PrognosisRateType_Mortality, PrognosisRateType_Qualitative, PrognosisRateType_Survival, PrognosisValue_00, PrognosisValue_10, PrognosisValue_20, PrognosisValue_30 } from './types.js';
import { Metadata_Population, PopulationType_General } from '../population/index.js';
export const PrognosisValueLabelMap = {
    [PrognosisValue_00]: 'Poor',
    [PrognosisValue_10]: 'Moderate',
    [PrognosisValue_20]: 'Good',
    [PrognosisValue_30]: 'Excellent',
};
export const PrognosisRateTypeLabelMap = {
    [PrognosisRateType_Survival]: 'Survival',
    [PrognosisRateType_Mortality]: 'Mortality',
    [PrognosisRateType_Qualitative]: 'Qualitative',
};
export const initialPrognosis = Object.freeze({
    rate: {
        type: PrognosisRateType_Survival,
        value: [0, 0],
    },
    timePeriod: {
        type: TimespanType_Day,
        value: 0,
    },
    population: {
        type: PopulationType_General,
    }
});
export const Metadata_Prognosis = {
    rate: {
        optional: false,
        valueType: 'object',
        description: 'Rate of the prognosis',
        metadata: {
            type: {
                optional: false,
                valueType: 'string',
                description: 'rate type'
            },
            value: {
                optional: false,
                description: 'rate value',
                valueType: 'string',
            }
        }
    },
    timePeriod: {
        optional: false,
        description: 'time period of the prognosis',
        valueType: 'object',
        metadata: {
            type: {
                optional: false,
                description: 'a time period',
                valueType: 'string',
            },
            value: {
                optional: false,
                description: 'numeric value to describe the amount of the time period',
                valueType: 'number',
            }
        }
    },
    population: Metadata_Population,
};
//# sourceMappingURL=consts.js.map